var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMind(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.728,
    height: 95.15,
    viewBox: "0 0 85.728 95.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_geist",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8261",
    "data-name": "Ellipse 8261",
    cx: 13.039,
    cy: 13.039,
    r: 13.039,
    transform: "translate(28.825 0)",
    fill: "none",
    stroke: "#4da2ef",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14942",
    "data-name": "Path 14942",
    d: "M44.364,63.61s-13.023-1.294-18.743.994c-4.122,1.649-6.77,14.616-8.8,21.384a14.632,14.632,0,0,1-5.056,7.364L4.96,98.627a6.35,6.35,0,0,0-2.46,5.019,4.4,4.4,0,0,0,2.709,4.064l.144.06a6.349,6.349,0,0,0,5.812-.48l10.058-6.3a11.258,11.258,0,0,0,4.647-5.81l5.068-14.423L30.8,97.886a5.486,5.486,0,0,1-3.378,5.022l-16.611,6.911a6.35,6.35,0,0,0-3.432,3.445l-.082.2a5.563,5.563,0,0,0,.694,5.455,6.142,6.142,0,0,0,4.067,2.4l16.262,2.262",
    transform: "translate(-2.5 -37.533)",
    fill: "none",
    stroke: "#4da2ef",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_561",
    "data-name": "Line 561",
    x2: 24.406,
    y2: 3.487,
    transform: "translate(23.426 72.262)",
    fill: "none",
    stroke: "#4da2ef",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14943",
    "data-name": "Path 14943",
    d: "M101.3,110.666l-23.99,7.088a8.9,8.9,0,0,0-6.074,6.217l-.023.083a4.988,4.988,0,0,0,1.719,5.213,6.349,6.349,0,0,0,5.876,1.069l18.5-5.92a32.082,32.082,0,0,1,5.35-1.219l13.535-1.883a6.14,6.14,0,0,0,4.067-2.4,5.563,5.563,0,0,0,.694-5.455l-.131-.317a6.041,6.041,0,0,0-3.264-3.277l-16.73-6.961a5.485,5.485,0,0,1-3.378-5.021l-.135-17.128,5.068,14.423a11.257,11.257,0,0,0,4.647,5.81l9.733,6.1a7.092,7.092,0,0,0,6.491.536,4.062,4.062,0,0,0,2.5-3.749v-.124a6.561,6.561,0,0,0-2.542-5.186l-6.723-5.211a14.628,14.628,0,0,1-5.056-7.364c-2.029-6.768-4.678-19.736-8.8-21.384-5.72-2.288-18.743-.994-18.743-.994",
    transform: "translate(-42.029 -37.533)",
    fill: "none",
    stroke: "#4da2ef",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMind);
export default __webpack_public_path__ + "static/media/mind.4bc50275a3100b6b526e9dbfc108f6fb.svg";
export { ForwardRef as ReactComponent };